import FilingWizard from "../../pages/filing/FilingWizard";

/** /filing/start: secure BPP portal lodging entry. */
export default function FilingStartGate() {
  return <FilingWizard />;
}
